<template>
  <div class="office-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/office/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>新希望商用资产</span>
    </p>
    <div class="section-container intro-box-content">
      <p>全国百强企业实力 定义现代商业投资典范</p>
      <p><br /></p>
      <p>新希望地产商用物业，拥有十余年专业运营经验，</p>
      <p>严选醇熟商圈板块，缔造优质资产。</p>
      <p>下辖7大项目，4大营销展示中心，</p>
      <p>创造国际化商用物业，每座皆为城市精华所在。</p>
      <p><br /></p>
      <p>总体量102345㎡，总资产达18亿。</p>
      <p>（写字楼面积48160㎡ / 商业面积54185㎡ ）</p>
    </div>

    <p class="section-title-line">
      <span>代表项目展示</span>
    </p>
    <div class="section-container">
      <el-row
        v-for="(item, index) in list"
        :key="item.name + index"
        class="office-item wow animate__slideInUp"
        data-wow-duration="500ms"
        :gutter="60"
      >
        <el-col :span="14">
          <div class="left-box">
            <img :src="item.image" alt="" />
          </div>
        </el-col>
        <el-col :span="10">
          <div class="right-box">
            <p class="name">{{ item.name }}</p>
            <p class="title">{{ item.title }}</p>
            <div class="desc">
              <p
                v-for="(item, index) in item.desc || []"
                :key="index"
                v-html="item"
              ></p>
            </div>
            <div class="footer">
              <p
                v-for="(item, index) in item.footer || []"
                :key="index"
                v-html="item"
              ></p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OfficePage",
  data() {
    return {
      list: [
        {
          name: "新希望大厦",
          title: "人民南路中轴写字楼地标 5A甲级商务空间",
          desc: [
            "落成时间：2010年",
            "总建筑面积：82000m²",
            "总占地面积：7638m²",
            "弹性商务空间：230-2900m²",
            "商铺面积区间：请咨询物业",
          ],
          footer: ["Add：成都市人民南路与航空路交汇处"],
          image: require("../../../assets/images/office/xxwds.png"),
        },
        {
          name: "新希望国际",
          title: "天府大道商务标杆 5A甲级商务空间",
          desc: [
            "落成时间：2010年",
            "总建筑面积：28万m²",
            "总占地面积：32600m²（约48.9亩）",
            "弹性商务空间：174-1935㎡ ，5A甲级Power office",
            "商铺面积区间：811-4448㎡，复合业态呈现",
          ],
          footer: ["Add：高新区天府大道天府三街69号"],
          image: require("../../../assets/images/office/xxwgj.png"),
        },
        {
          name: "新希望商鼎国际",
          title: "南二环桐梓林CBD门户商务坐标 5A甲级商务空间",
          desc: [
            "落成时间：2008年",
            "总建筑面积：14.3万m²",
            "总占地面积：请咨询物业",
            "弹性商务空间：请咨询物业",
            "商铺面积区间：请咨询物业",
          ],
          footer: ["Add：成都市人民南路与二环路交汇处"],
          image: require("../../../assets/images/office/xxwsdgj.png"),
        },
        {
          name: "新希望中鼎国际",
          title: "南三环金融城商务坐标 5A甲级商务空间",
          desc: [
            "落成时间：2014年",
            "总建筑面积：18万m²",
            "总占地面积：59274m²（约89亩）",
            "弹性商务空间：300-1300㎡",
            "商铺面积区间：请咨询物业",
          ],
          footer: ["Add：南三环锦江创业园金石路376号"],
          image: require("../../../assets/images/office/xxwzdgj.png"),
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.office-container {
  .office-item {
    background: #f3f3f4;
    width: 100%;
    height: 100%;
    padding: 50px;
    overflow: hidden;
    margin-top: 30px;

    .left-box {
      width: 100%;
      overflow: hidden;

      > img {
        max-width: 100%;
      }
    }

    .right-box {
      color: #565c61;
      .name {
        font-size: 28px;
        color: #008048;
        padding-top: 20px;
        padding-bottom: 15px;
        padding-left: 2px;
      }

      .title {
        text-align: justify;
        padding-left: 2px;
        font-size: 14px;
        line-height: 20px;
      }

      .desc {
        margin-top: 40px;
        font-size: 13px;
        line-height: 27px;
      }

      .footer {
        margin-top: 30px;
        font-size: 14px;
      }
    }
  }
}
</style>
